import { ListPageLayout } from "@/components/list-page-layout";
import { usePageTitle } from "@/hooks/use-page-title";
import { CustomChannelsDataTable } from "./custom-channels-data-table";
import { CustomChannelsRuleSetSelector } from "./custom-channels-ruleset-selector";

export default function CustomChannelsListView() {
  usePageTitle("Custom List View");

  return (
    <ListPageLayout
      pageType="custom-channels::list"
      title="Custom List View"
      ariaLabel="Custom Channels List"
      headingId="custom-channels-list-heading"
      headerExtras={<CustomChannelsRuleSetSelector />}
    >
      <CustomChannelsDataTable />
    </ListPageLayout>
  );
}
